export default __webpack_public_path__ + "static/media/bg38.e6717f9d.jpg";